/**
 * État vide : aucun ingrédient ajouté
 */

import React from "react";
import { motion } from "framer-motion";
import { glassPanel } from "../../../../components/layout/UserLayout/designTokens";
import { quickStartIngredients } from "../constants/ingredients.js";

export default function EmptyState({ addIngredient, getIngredientLabel, t }) {
  return (
    <motion.div
      className={`${glassPanel} rounded-2xl p-8 sm:p-10 text-center`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <div className="text-5xl sm:text-6xl mb-4">🧊</div>
      <h3 className="text-xl font-bold text-white mb-2">
        {t("startByAddingIngredients")}
      </h3>
      <p className="text-white/80 text-sm max-w-md mx-auto mb-6">
        {t("addIngredientsDescription")}
      </p>
      <p className="text-xs text-white/60 mb-3">
        {t("suggestionsToStart") || "Cliquez pour ajouter :"}
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {quickStartIngredients.map((ing) => (
          <button
            key={ing}
            type="button"
            onClick={() => addIngredient(ing)}
            className="px-4 py-2 bg-orange-500/30 hover:bg-orange-500/50 text-white rounded-xl text-sm font-medium border border-orange-400/50 transition-colors"
          >
            + {getIngredientLabel(ing)}
          </button>
        ))}
      </div>
    </motion.div>
  );
}
